'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIModal from 'UIComponents/dialog/UIModal';
import { getProductFeatureDescriptionKey } from 'self-service-api/core/utilities/getFeatureDescriptionKey';
import { GYPSUM, KOALA, OBSIDIAN } from 'HubStyleTokens/colors';
import ChecklistItem from 'pricing-pages-unified-ui/components/common/ChecklistItem';
const ModalBodyContainer = styled.div.withConfig({
  displayName: "FeaturesModal__ModalBodyContainer",
  componentId: "padabz-0"
})(["padding:40px;"]);
const ModalHeaderContainer = styled.div.withConfig({
  displayName: "FeaturesModal__ModalHeaderContainer",
  componentId: "padabz-1"
})(["background-color:", ";height:70px;width:100%;border-bottom:1px solid ", ";display:flex;align-items:center;padding-left:40px;padding-right:20px;"], GYPSUM, KOALA);
const ModalHeader = styled.div.withConfig({
  displayName: "FeaturesModal__ModalHeader",
  componentId: "padabz-2"
})(["flex-grow:1;font-size:20px;font-weight:600;"]);

const FeaturesModal = ({
  header,
  features,
  onModalClose,
  productLine
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(ModalHeaderContainer, {
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        children: header
      }), /*#__PURE__*/_jsx(UICloseButton, {
        color: OBSIDIAN,
        onClick: onModalClose
      })]
    }), /*#__PURE__*/_jsx(ModalBodyContainer, {
      children: Object.keys(features).map(feature => /*#__PURE__*/_jsx(ChecklistItem, {
        tooltipMessage: getProductFeatureDescriptionKey(feature, productLine),
        message: `pricing-pages.features.${feature}.name`,
        className: "m-bottom-5",
        fontSize: 16
      }, feature))
    })]
  });
};

export default FeaturesModal;